export default __webpack_public_path__ + "static/media/Coverings of the Grand Monarch.f9270939.jpg";